'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { dest } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputRootShared.js';
import { AskInputRootSideEffects } from '#pplx/frontend/apps/ask/ask-input/ask-input-provider/components/AskInputRootSideEffects.js';
import React from 'react';
export const AskInputRoot = ({ children, queryDraftKey, defaultSearchModel, defaultSources, defaultCompareModels, workspaceDirectories, }) => (_jsxs(dest.Provider, { initialValue: {
        queryDraftKey,
        defaultSearchModel,
        defaultSources,
        defaultCompareModels,
        workspaceDirectories,
    }, children: [_jsx(AskInputRootSideEffects, { workspaceDirectories: workspaceDirectories }), children] }));
//# sourceMappingURL=AskInputRoot.js.map